export { default } from './HoldsPickupBranchSelect';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsPickupBranchSelect/index.js